import { render, staticRenderFns } from "./ConfigMailUserCard.vue?vue&type=template&id=286a9ce6&scoped=true&"
import script from "./ConfigMailUserCard.vue?vue&type=script&lang=js&"
export * from "./ConfigMailUserCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMailUserCard.vue?vue&type=style&index=0&id=286a9ce6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a9ce6",
  null
  
)

export default component.exports